import type { FaireProductEntity } from "../../entity_types/product";

export const p_7t40rgogm1: FaireProductEntity = {
  token: "p_7t40rgogm1",
  type: "product",
  name: "Grateful Dead® Tie Dye Dancing Bear",
  brandToken: "b_6tmqj9f90u",
  brandName: "fabdog",
  imageUrl:
    "https://cdn.faire.com/fastly/bf4f907ee69adefd6e45d9c349dddfc5ddc8f40d83372b067483b0ba788a4905.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c118c2c83ba97269cb49ecffc8caa46b8a5fc9adc364c204eb991ff0d5b789e7.jpeg",
  ],
  priceDollars: 9.65,
  description:
    "Be grateful, keep dancing.\n\nOur fabdog® x Grateful Dead collection celebrates iconic style and timeless play. Each toy channels the band’s legendary spirit with vibrant designs, premium plush materials, and bold character details. It’s a psychedelic playtime experience for every cool pup.\n\n\n",
  tags: [],
  msrpDollars: 19.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:10.369Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
